import { DocumentBlobListRequest } from "@bitory-gmbh/bsm";
import { useDocumentBlobListQuery } from "@/services/backend/filestorage/api/document-blob-api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { TableLoadingRow } from "@/shared/components/tables/table-loading-row";
import { TableRtkErrorRow } from "@/shared/components/tables/table-rtk-error-row";
import t from "@/lang/lang";
import { DocumentBlobSheet } from "@/services/backend/filestorage/components/document-blob-sheet";
import { DocumentBlobDeleteDialog } from "@/services/backend/filestorage/components/document-blob-delete-dialog";
import { TableEmptyRow } from "@/shared/components/tables/table-empty-row";

export function DocumentBlobTable({
  request,
  disabled = false,
}: {
  request: DocumentBlobListRequest;
  disabled?: boolean;
}) {
  const { data, error, isLoading } = useDocumentBlobListQuery(request);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("Art")}</TableHead>
          <TableHead>{t("Name")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {error && <TableRtkErrorRow error={error} colSpan={2} />}
        {isLoading && <TableLoadingRow colSpan={2} />}
        {data &&
          data.items.map((item) => (
            <TableRow key={item.filename}>
              <TableCell>{t(item.kind)}</TableCell>
              <TableCell>
                <DocumentBlobSheet base={item} />
              </TableCell>
              <TableCell>{item.version !== "" && item.version}</TableCell>
              <TableCell>
                <DocumentBlobDeleteDialog base={item} disabled={disabled} />
              </TableCell>
            </TableRow>
          ))}
        {data && data.items.length === 0 && (
          <TableEmptyRow colSpan={2} text={t("Keine Dateien hochgeladen")} />
        )}
      </TableBody>
    </Table>
  );
}
